import prospectsTypes from '../../constants/prospectsTypes'
export * from './delete'
export * from './getindex'
export * from './getxlsx'
export * from './resend'

const set_prospect_errors = (messages) => {
  return {
    type: prospectsTypes.set_errors,
    payload: messages
  }
}

export {
  set_prospect_errors,
}



// WEBPACK FOOTER //
// ./src/js/actions/prospects/index.js